import React from "react";
import './style.less';
import {Row, Col,Image} from "antd";

export default class TrainingContent1 extends React.Component{
    render() {
        return (
            <div className={'training-content1'}>
                <div className={'content-box'}>
                    <Row>
                        <Col xs={24} sm={24} md={6} lg={6} xl={6} className="imgCol">
                            {/* <Image preview={false} height={219} src={"http://qiniu.metridynamic.com/image/training/pilot.png"}/> */}
                        </Col>
                        <Col span="16" xs={{ span: 24 }} lg={{ span: 16}} className={"content-desc"}>
                            <p className={"title"}>专业的无人机飞行员</p>
                            <p className={"content"}>为满足P系列无人机产品试飞、交付、客户培训、AOPA培训等需求，我们有专业技术人员和管理人员，针对无人机产品和解决方案提供系统化和层次化的专业培训服务。</p>
                        </Col>
                    </Row>
                </div>
                <div className={"content-box"}>
                    <Row>
                        <Col xs={24} sm={24} md={6} lg={6} xl={6} className="imgCol2">
                            {/* <Image preview={false} height={246} src={"http://qiniu.metridynamic.com/image/training/site.png"}/> */}
                        </Col>
                        <Col span="16" className={"content-desc"} xs={{ span: 24 }} lg={{ span: 16}}>
                            <p className={"title"}>设施完备的飞行基地</p>
                            <p className={"content"}>力动几何飞机基地位于成都市青白江区，基地占地面积1000亩，距离成都仅 22公里，交通便利，环境优美, 基础设施齐全，周边旅游景点众多，满足各种测试，演示, 培训等需求。</p>
                        </Col>
                    </Row>
                </div>
            </div>
        )
        }
    }
